<template>
  <div
    v-if="hasAvailableFilter"
    class="ce-searchFilterBar-group">
    <div
      class="ce-searchFilterBar-groupHeadline"
      v-if="showHeadline">
      {{ $t(`productSearch.informationType.${informationType}`) }}
    </div>

    <div>
      <filter-element
        class="ce-searchFilterBar-section"
        v-for="filter in filters"
        :key="`filter-section-${filter.filterCode}`"
        :filter-code="filter.filterCode"
        :config="filter.config" />
    </div>
  </div>
</template>

<script>
import FilterElement from './filters/FilterElement.vue';

export default {
  props: {
    filters: {
      type: Array,
      required: true,
    },
    informationType: {
      type: String,
      required: true,
    }
  },
  components: { FilterElement },
  computed: {
    showHeadline() {
      return this.informationType !== 'generic';
    },
    hasAvailableFilter() {
      return this.filters.filter((filter) => {
        if (filter.config) {
          if (filter.config.disabled === true) {
            return false;
          }

          if (filter.config.options && Array.isArray(filter.config.options)) {
            return filter.config.options.filter((o) => !o.disabled).length > 0;
          }
        }

        return true;
      }).length > 0;
    }
  }
};
</script>
